<template>
  <transition name="fade" mode="out-in" v-if="show">
    <div class="gs-app fixed z-40 flex justify-center items-center inset-0">
      <div class="fixed inset-0 w-full h-full opacity-50 bg-white"></div>
      <div
        class="max-h-full w-full h-full p-8 flex items-center justify-center"
      >
        <div
          class="bg-white rounded-lg shadow-2xl relative flex flex-col overflow-hidden"
          :class="{ 'gm-sequence-assignment-modal': seqAction && (seqAction.type === 'tag' || seqAction.type === 'list'), 'gm-sequence-split-modal': seqAction && seqAction.type === 'split', 'gm-sequence-starting-rules-modal': seqAction && seqAction.type === 'saverule' }"
          style="width: 640px"
          v-for="slot in slots"
          :key="slot.name"
        >
          <div class="">
            <div class="px-20 pt-10 pb-4 relative">
              <div class="flex justify-center text-lg font-bold">
                {{ title }}
              </div>
              <div
                class="absolute cursor-pointer"
                style="right: 30px; top: 30px"
                @click="close()"
              >
                <CloseIcon class="h-6 w-6 text-grey-700"/>
              </div>
            </div>
            <VuePerfectScrollbar>
              <div class="configuration-content text-dark">
                <div class="px-10 py-6">
                  <div
                    class="configure-start-rules gm-sequence-starting-rules-content"
                    v-if="
                      seqAction &&
                      seqAction.type &&
                      seqAction.type === 'saverule'
                    "
                  >
                    <StartingRules
                      ref="startRule"
                      :model="model"
                      @updateModel="model = $event"
                      @createNewList="createNewList"
                      @createNewTag="createNewTag"
                    ></StartingRules>
                    <div class="flex justify-end pt-4">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        @click="saveRuleTrigger"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_done') }}
                      </gd-button>
                    </div>
                  </div>
                  <div
                    class="configure-content"
                    v-if="
                      seqAction && seqAction.type && seqAction.type === 'tag'
                    "
                  >
                    <TagNode
                      ref="tagRule"
                      :model="model"
                      @updateModel="model = $event"
                      @createNewTag="createNewTag"
                    ></TagNode>
                    <div class="mb-6">
                      <p class="font-semibold text-base text-dark mb-2">
                        {{ $t('frontend_groovemail_sequences_configmenu_send_status') }}
                      </p>
                      <div class="relative">
                        <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                        <select
                          class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                          v-model="localModel.status"
                          @change="statusChanged"
                        >
                          <option
                            v-for="status in statusOptions"
                            :key="status.id"
                            :value="status.value"
                          >
                            {{ status.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex justify-end pt-4">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        id="savetagbtn"
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        :disabled="model.savetagbtn"
                        @click="saveTagTrigger"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_done') }}
                      </gd-button>
                    </div>
                  </div>
                  <div
                    class="configure-content"
                    v-if="
                      seqAction && seqAction.type && seqAction.type === 'list'
                    "
                  >
                    <ListNode
                      ref="listRule"
                      :model="model"
                      @updateModel="model = $event"
                      @createNewList="createNewList"
                    ></ListNode>
                    <div class="mb-6">
                      <p class="font-semibold text-base text-dark mb-2">
                        {{ $t('frontend_groovemail_sequences_configmenu_send_status') }}
                      </p>
                      <div class="relative">
                        <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                        <select
                          class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                          v-model="localModel.status"
                          @change="statusChanged"
                        >
                          <option
                            v-for="status in statusOptions"
                            :key="status.id"
                            :value="status.value"
                          >
                            {{ status.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex justify-end pt-4">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        id="savelistbtn"
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        @click="saveListTrigger"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_done') }}
                      </gd-button>
                    </div>
                  </div>
                  <div
                    class="configure-content"
                    v-if="
                      seqAction && seqAction.type && seqAction.type === 'sms'
                    "
                  >
                    <SendSmsNode
                      ref="smsnode"
                      :model="model"
                      @updateModel="model = $event"
                      @createNewSmsSender="createNewSmsSender"
                    ></SendSmsNode>
                    <div class="mb-6">
                      <p class="font-semibold text-base text-dark mb-2">
                        {{ $t('frontend_groovemail_sequences_configmenu_send_status') }}
                      </p>
                      <div class="relative">
                        <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                        <select
                          class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                          v-model="localModel.status"
                          @change="statusChanged"
                        >
                          <option
                            v-for="status in statusOptions"
                            :key="status.id"
                            :value="status.value"
                          >
                            {{ status.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex justify-end pt-4">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        id="savesmsbtn"
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        @click="saveSmsTrigger('smsnode')"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_done') }}
                      </gd-button>
                    </div>
                  </div>
                  <div
                    class="configure-content"
                    v-if="
                      seqAction && seqAction.type && seqAction.type === 'postal'
                    "
                  >
                    <PostalNode
                      :model="model"
                      @updateModel="model = $event"
                      @showLoader="showLoader"
                      @hideLoader="hideLoader"
                    ></PostalNode>
                    <div class="mb-6" v-if="fetchClosemIntegeration()">
                      <p class="font-semibold text-base text-dark mb-2">
                        {{ $t('frontend_groovemail_sequences_configmenu_send_status') }}
                      </p>
                      <div class="relative">
                        <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                        <select
                          class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                          v-model="localModel.status"
                          @change="statusChanged"
                        >
                          <option
                            v-for="status in statusOptions"
                            :key="status.id"
                            :value="status.value"
                          >
                            {{ status.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex justify-end pt-4" v-if="fetchClosemIntegeration()">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        id="savepostalbtn"
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        @click="savePostalTrigger()"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_done') }}
                      </gd-button>
                    </div>
                  </div>
                  <div
                    class="configure-content"
                    v-if="
                      seqAction && seqAction.type && seqAction.type === 'goto'
                    "
                  >
                    <GotoNode
                      :model="model"
                      @updateModel="model = $event"
                    ></GotoNode>
                    <div class="mb-6">
                      <p class="font-semibold text-base text-dark mb-2">
                        {{ $t('frontend_groovemail_sequences_configmenu_send_status') }}
                      </p>
                      <div class="relative">
                        <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                        <select
                          class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                          v-model="localModel.status"
                          @change="statusChanged"
                        >
                          <option
                            v-for="status in statusOptions"
                            :key="status.id"
                            :value="status.value"
                          >
                            {{ status.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex justify-end pt-4">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        id="savegotobtn"
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        @click="saveGotoTrigger"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_done') }}
                      </gd-button>
                    </div>
                  </div>
                  <div
                    class="configure-content"
                    v-if="
                      seqAction &&
                      seqAction.type &&
                      seqAction.type === 'editdetail'
                    "
                  >
                    <EditDetail
                      ref="editnode"
                      :model="model"
                      @updateModel="model = $event"
                      @createNewList="createNewList"
                      @createNewTag="createNewTag"
                      @createNewEmailSender="createNewEmailSender"
                      @createNewSmsSender="createNewSmsSender"
                      @saveOnEmailContentReset="saveOnEmailContentReset"
                      @showLoader="showLoader"
                      @hideLoader="hideLoader"
                    ></EditDetail>
                    <div class="mb-6">
                      <p class="font-semibold text-base text-dark mb-2">
                        {{ $t('frontend_groovemail_sequences_configmenu_send_status') }}
                      </p>
                      <div class="relative">
                        <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                        <select
                          class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                          v-model="localModel.status"
                          @change="statusChanged"
                        >
                          <option
                            v-for="status in statusOptions"
                            :key="status.id"
                            :value="status.value"
                          >
                            {{ status.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex justify-end pt-4">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        id="emailbtn"
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        @click="updateTrigger('editnode')"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_update') }}
                      </gd-button>
                    </div>
                  </div>
                  <div
                    class="configure-content"
                    v-if="
                      seqAction && seqAction.type && seqAction.type === 'email'
                    "
                  >
                    <EmailNode
                      ref="emailnode"
                      :model="model"
                      @updateModel="model = $event"
                      @createNewEmailSender="createNewEmailSender"
                      @showLoader="showLoader"
                      @hideLoader="hideLoader"
                    ></EmailNode>
                    <div class="mb-6">
                      <p class="font-semibold text-base text-dark mb-2">
                        {{ $t('frontend_groovemail_sequences_configmenu_send_status') }}
                      </p>
                      <div class="relative">
                        <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                        <select
                          class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                          v-model="localModel.status"
                          @change="statusChanged"
                        >
                          <option
                            v-for="status in statusOptions"
                            :key="status.id"
                            :value="status.value"
                          >
                            {{ status.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex justify-end pt-4">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        id="emailbtn"
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        @click="saveEmailTrigger('emailnode')"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_done') }}
                      </gd-button>
                    </div>
                  </div>
                  <div
                    class="configure-content"
                    v-if="
                      seqAction && seqAction.type && seqAction.type === 'delay'
                    "
                  >
                    <DelayNode
                      :model="model"
                      @updateModel="model = $event"
                    ></DelayNode>
                    <div class="mb-6">
                      <p class="font-semibold text-base text-dark mb-2">
                        {{ $t('frontend_groovemail_sequences_configmenu_send_status') }}
                      </p>
                      <div class="relative">
                        <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                        <select
                          class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                          v-model="localModel.status"
                          @change="statusChanged"
                        >
                          <option
                            v-for="status in statusOptions"
                            :key="status.id"
                            :value="status.value"
                          >
                            {{ status.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex justify-end pt-4">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        id="delaybtn"
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        @click="saveDelayTrigger"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_done') }}
                      </gd-button>
                    </div>
                  </div>
                  <div
                    class="configure-content"
                    v-if="
                      seqAction && seqAction.type && seqAction.type === 'split'
                    "
                  >
                    <SplitNode
                      :model="model"
                      @updateModel="model = $event"
                    ></SplitNode>
                    <div class="mb-6">
                      <p class="font-semibold text-base text-dark mb-2">
                        {{ $t('frontend_groovemail_sequences_configmenu_send_status') }}
                      </p>
                      <div class="relative">
                        <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
                        <select
                          class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                          v-model="localModel.status"
                          @change="statusChanged"
                        >
                          <option
                            v-for="status in statusOptions"
                            :key="status.id"
                            :value="status.value"
                          >
                            {{ status.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex justify-end pt-4">
                      <gd-button
                        size="auto"
                        @click="close()"
                        >{{ $t('frontend_cancel') }}</gd-button
                      >
                      <gd-button
                        id="delaybtn"
                        variant="primary"
                        size="auto"
                        class="ml-2"
                        @click="saveSplitTrigger"
                      >
                        {{ $t('frontend_groovemail_sequences_configmenu_done') }}
                      </gd-button>
                    </div>
                  </div>
                </div>
              </div>
            </VuePerfectScrollbar>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import auth from '@groovepages/gd-lib/auth';
import TagNode from './TagNode';
import ListNode from './ListNode';
import EmailNode from './EmailNode';
import EditDetail from './EditDetail';
import DelayNode from './DelayNode';
import SendSmsNode from './SendSmsNode';
import GotoNode from './GotoNode';
import SplitNode from './SplitNode';
import StartingRules from './StartingRules';
import PostalNode from './PostalNode';

// import icons
import CloseIcon from '@/assets/images/icons/new/close_small_new.svg';
import DownIcon from '@/assets/images/icons/new/down_new.svg';

export default {
  name: 'ConfigMenu',
  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      localModel: this.model,
      title: '',
      slots: [],
      show: false,
      seqAction: {
        type: null,
        value: null,
      },
    };
  },

  created() {
    this.slots = [{ name: this.title, slot: this.title }];
  },

  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    createNewTag(type) {
      this.$emit('createNewTag', type);
    },

    createNewList(type) {
      this.$emit('createNewList', type);
    },

    createNewEmailSender(type) {
      this.$emit('createNewEmailSender', type);
    },

    createNewSmsSender(type) {
      this.$emit('createNewSmsSender', type);
    },

    statusChanged() {
      this.model.status = this.localModel.status;
    },

    zoomIn(zoomRatio) {
      this.$emit('zoomIn', zoomRatio);
    },

    zoomOut(zoomRatio) {
      this.$emit('zoomOut', zoomRatio);
    },

    toggleConfigMenu(flag) {
      this.show = flag;
    },

    close() {
      this.show = false;
      this.$emit('sideMenuClosed');
    },

    saveEmailTrigger(name) {
      if (this.$refs[name][0].validate()) {
        this.$emit('saveEmailTrigger');
      }
    },

    updateTrigger(name) {
      if (this.$refs[name][0].validate()) {
        this.$emit('updateEdittedModuleData');
      }
    },

    saveTagTrigger() {
      if (this.seqAction.type === 'tag') {
        const data = {
          action: this.seqAction.value,
        };
        this.$emit('saveTagTrigger', data);
      }
    },

    saveListTrigger() {
      if (this.seqAction.type === 'list') {
        const data = {
          action: this.seqAction.value,
        };
        this.$emit('saveListTrigger', data);
      }
    },

    saveSmsTrigger(name) {
      if (this.$refs[name][0].validate()) {
        this.$emit('saveSmsTrigger');
      }
    },

    saveGotoTrigger() {
      this.localModel.gotoassigned.push({
        step: this.localModel.gotostep,
        flow: this.localModel.gotoflow,
      });
      this.$emit('saveGotoTrigger');
    },

    saveRuleTrigger() {
      this.$emit('saveRuleTrigger');
    },

    saveSplitTrigger() {
      this.$emit('saveSplitTrigger');
    },

    saveDelayTrigger() {
      this.$emit('saveDelayTrigger');
    },

    updateEdittedModuleData() {
      this.$emit('updateEdittedModuleData');
    },

    saveOnEmailContentReset() {
      this.$emit('saveOnEmailContentReset');
    },

    updateTabForStartRule(currentTab) {
      if (this.$refs && this.$refs.startRule) {
        this.$refs.startRule[0].handleStartRuleTabChange(currentTab);
      }
    },

    passCreatedEmailSender(senderData, passTo) {
      if (passTo === 2) {
        this.$refs.emailnode[0].updateEmailSenderData(senderData);
      } else if (passTo === 7) {
        this.$refs.editnode[0].updateEmailSenderData(senderData);
      }
    },

    passCreatedSmsSender(senderData, passTo) {
      if (passTo === 3) {
        this.$refs.smsnode[0].updateSmsSenderData(senderData);
      } else if (passTo === 7) {
        this.$refs.editnode[0].updateSmsSenderData(senderData);
      }
    },

    passCreatedLists(listData, passTo) {
      if (passTo === 1) {
        this.$refs.startRule[0].updateListData(listData);
      } else if (passTo === 6) {
        this.$refs.listRule[0].updateListData(listData);
      } else if (passTo === 7) {
        this.$refs.editnode[0].updateListData(listData);
      }
    },

    passCreatedTags(tagData, passTo) {
      if (passTo === 1) {
        this.$refs.startRule[0].updateTagData(tagData);
      } else if (passTo === 4) {
        this.$refs.tagRule[0].updateTagData(tagData);
      } else if (passTo === 7) {
        this.$refs.editnode[0].updateTagData(tagData);
      }
    },

    savePostalTrigger() {
      this.$emit('savePostalTrigger');
    },

    fetchClosemIntegeration() {
      let integrations = [];
      const user = auth.authenticatedUser();
      if (user.metadata && user.metadata.integrations) {
        integrations = user.metadata.integrations.filter(
          ele => ele.type === 'closem-integration'
        );
      }
      if (integrations && integrations.length) {
        return integrations[integrations.length - 1].id;
      }
      return 0;
    },
  },

  computed: {
    statusOptions() {
      return [
        {
          id: 1,
          label: this.$t('frontend_groovemail_sequence_node_status_active'),
          value: 1,
        },
        {
          id: 2,
          label: this.$t('frontend_groovemail_sequence_node_status_inactive'),
          value: 0,
        },
      ];
    },
  },

  components: {
    CloseIcon,
    DownIcon,
    TagNode,
    ListNode,
    EditDetail,
    EmailNode,
    DelayNode,
    SendSmsNode,
    GotoNode,
    SplitNode,
    StartingRules,
    VuePerfectScrollbar,
    PostalNode,
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },

    'model.status': function watchModelStatus() {
      this.localModel.status = this.model.status;
    },

    'model.edittype': function watchModelEditType() {
      this.localModel.edittype = this.model.edittype;
    },
  },
};
</script>

<style lang="scss">
.configuration-content {
  min-height: auto;
  max-height: calc(100vh - 120px);
  
  .tabs {
    width: 100%;
    border-bottom: 1px solid #dcdcea;
    
    &__item {
      margin-right: 16px;
      padding: 0 0 8px;
   
      .text-sm {
        font-weight: 400;
        padding: 0;
      }   
      
      &_active {
        .text-sm {
          font-weight: 700;
        }
      }
    }
    
  }
}


.sequence-modal-inner {
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.sel-icon {
  z-index: 9;
  top: 12px;
  right: 12px;
}

.save-wrapper {
  z-index: 100;
}

.width-large {
  width: 600px;
}

.action-save-btn {
  border-radius: 6px !important;
}

.zoom-in-btn {
  bottom: 120px;
  left: -47px;
}

.zoom-out-btn {
  bottom: 90px;
  left: -47px;
}
</style>

<style scoped>
.gm-sequence-starting-rules-modal {
  width: min(720px, calc(100vw - 24px)) !important;
  max-width: calc(100vw - 24px);
}

.gm-sequence-starting-rules-modal > div:first-child > .px-20.pt-10.pb-4 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 44px;
  gap: 12px;
  padding: 20px 20px 16px;
}

.gm-sequence-starting-rules-modal > div:first-child > .px-20.pt-10.pb-4 > .flex.justify-center {
  min-width: 0;
  overflow-wrap: anywhere;
}

.gm-sequence-starting-rules-modal > div:first-child > .px-20.pt-10.pb-4 > .absolute {
  position: static;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  min-width: 44px;
  height: 44px;
}

.gm-sequence-starting-rules-modal .configuration-content > .px-10.py-6 {
  padding: 20px;
}

.gm-sequence-starting-rules-content > .flex.justify-end.pt-4 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  padding-top: 20px;
}

.gm-sequence-starting-rules-content > .flex.justify-end.pt-4 > * {
  width: 100%;
  min-width: 0 !important;
  min-height: 44px;
  margin-left: 0;
  box-sizing: border-box;
}

.gm-sequence-starting-rules-content > .flex.justify-end.pt-4 > *:first-child {
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border-color: var(--gs-border);
  box-shadow: none;
}

@media (max-width: 40rem) {
  .gm-sequence-starting-rules-modal {
    width: calc(100vw - 24px) !important;
  }

  .gm-sequence-starting-rules-modal .configuration-content > .px-10.py-6 {
    padding: 16px;
  }
}
</style>

<style scoped>
@media (max-width: 40rem) {
  .gm-sequence-assignment-modal {
    width: 100% !important;
    max-width: 100%;
  }

  .gm-sequence-assignment-modal > div:first-child > .px-20.pt-10.pb-4 {
    padding: 1.25rem 3.5rem 1rem;
  }

  .gm-sequence-assignment-modal .configuration-content > .px-10.py-6 {
    padding: 1rem;
  }

  .gm-sequence-assignment-modal .configure-content > .mb-6 select {
    min-height: 2.75rem;
    height: 2.75rem;
  }

  .gm-sequence-assignment-modal .configure-content > .flex.justify-end.pt-4 {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 0.75rem;
    padding-top: 1rem;
  }

  .gm-sequence-assignment-modal .configure-content > .flex.justify-end.pt-4 > * {
    width: 100%;
    min-width: 0 !important;
    min-height: 2.75rem;
    margin-left: 0;
    box-sizing: border-box;
  }

  .gm-sequence-assignment-modal .configure-content > .flex.justify-end.pt-4 > *:first-child {
    color: var(--gs-foreground);
    background: var(--gs-surface);
    border-color: var(--gs-border);
  }

  .gm-sequence-split-modal {
    width: 100% !important;
    max-width: 100%;
  }

  .gm-sequence-split-modal > div:first-child > .px-20.pt-10.pb-4 {
    padding: 1.25rem 3.5rem 1rem;
  }

  .gm-sequence-split-modal .configuration-content > .px-10.py-6 {
    padding: 1rem;
  }

  .gm-sequence-split-modal .configure-content > .mb-6 select {
    min-height: 2.75rem;
    height: 2.75rem;
  }

  .gm-sequence-split-modal .configure-content > .flex.justify-end.pt-4 {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 0.75rem;
    padding-top: 1rem;
  }

  .gm-sequence-split-modal .configure-content > .flex.justify-end.pt-4 > * {
    width: 100%;
    min-width: 0 !important;
    min-height: 2.75rem;
    margin-left: 0;
    box-sizing: border-box;
  }

  .gm-sequence-split-modal .configure-content > .flex.justify-end.pt-4 > *:first-child {
    color: var(--gs-foreground);
    background: var(--gs-surface);
    border-color: var(--gs-border);
  }
}
</style>
